module.exports = __webpack_public_path__ + "img/logo.e4ae2f12.png";